module.exports = __webpack_public_path__ + "1a2371b90d361763781a967ddc5800a7.svg";